import { BreadcrumbLabel } from '@zvoove-market/shared';
import { BehaviorSubject, Observable, filter, map } from 'rxjs';

export class DashboardTileDetailBreadcrumb {
  public static breadcrumbData$ = new BehaviorSubject<string | null>(null);
  public static getBreadcrumb(): BreadcrumbLabel | Observable<BreadcrumbLabel> {
    return DashboardTileDetailBreadcrumb.breadcrumbData$.pipe(
      filter((x) => !!x),
      map((name) => $localize`:@@general.changeSomething:${name} bearbeiten`)
    );
  }
}
